import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import { DialogContent, DialogTitle, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import EventEHRRadioButton from "../../../../component-lib/Molecules/radioButton/EventEHRRadioButton";
import TransferToJHCForm from "../../../../forms/TransferToJHCForm";
import TransferToClinicLocationForm from "../../../../forms/TransferToBaseCampForm";
import { useDispatch, useSelector } from "react-redux";
import {
  patchChiefComplaintData,
  postTransferEMSPatient,
  postTransferPatient,
} from "../../patientSaga";
import TransferOffPropertiesForm from "../../../../forms/TransferOffPropertiesForm";
import { componentKey } from "../../patientSlice";
import ClearEMSForm from "../../../../forms/ClearEmsForm";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: "16px 24px",
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiPaper-root": {
    width: "708px", // Set your custom width here
    maxWidth: "none", // Prevents Material-UI from overriding your width
  },
}));

interface EMSDispositionDialogProps {
  open: boolean;
  visitNoteId?: string;
  patientId?: string;
  handleDischargeClick?: (type: any) => void;
  handleCloseDialog: () => void;
}

export default function EMSTransferDialog({
  open = false,
  patientId,
  handleCloseDialog,
}: EMSDispositionDialogProps) {
  const { tempVisitData } = useSelector((state: any) => state[componentKey]);

  const dispatch = useDispatch();

  const [selectedType, setSelectedType] = useState("transferOffProperty");
  const handleClose = () => {
    handleCloseDialog();
  };

  const getTransportLevel = (data: any) => {
    return data?.property === "basicLifeSupport"
      ? "Basic Life Support"
      : data?.property === "advanceLifeSupport"
        ? "Advance Life Support"
        : data?.property === "criticalCareTransport"
          ? "Crirtical Care Transport"
          : data?.property === "otherVehicle"
            ? "Other Vehicle"
            : undefined;
  };

  const handleSubmitClick = (selectedType: string, data: any) => {
    switch (selectedType) {
      case "transferToJHC":
        const payload1 = {
          apiPayload: {
            patientId: tempVisitData?.patientId,
            visitId: tempVisitData?.id,
            status: "transferToJHC",
            departmentId: data?.jamboreeHealthCenter,
          },
          // dataOfDischargeForm: dataOfDischargeForm,
        };
        dispatch(postTransferEMSPatient(payload1));
        break;
      case "transferOffProperty":
        const payload2 = {
          apiPayload: {
            patientId: tempVisitData?.patientId,
            visitId: tempVisitData?.id,
            transport_level: getTransportLevel(data),
            status: "transferOffProperty",
            hospitalName: data?.hospital,
          },
          // dataOfDischargeForm: dataOfDischargeForm,
          patientId: patientId,
        };
        dispatch(postTransferEMSPatient(payload2));

        break;
      case "transferToClinicLocation":
        const payload3 = {
          apiPayload: {
            patientId: tempVisitData?.patientId,
            visitId: tempVisitData?.id,
            status: "transferToClinic",
            facilityId: data?.basecamp,
          },
          patientId: patientId,
        };
        dispatch(postTransferEMSPatient(payload3));
        break;
      case "clearEMS":
        const payload4 = {
          apiPayload: {
            patientId: tempVisitData?.patientId,
            visitId: tempVisitData?.id,
            status: "discharged",
          },
          patientId: patientId,
        };

        const payloadForVisitUpdate = {
          apiPayload: {
            incidentlocation: data?.injuryLocation,
            witnessName: data?.witnessName,
            injuryType: data?.injuryLocation,
            injuryLocation: data?.incidentLocation,
          },
          visitId: tempVisitData?.id,
        };

        dispatch(patchChiefComplaintData(payloadForVisitUpdate));
        dispatch(postTransferEMSPatient(payload4));
        break;
    }
  };

  return (
    <React.Fragment>
      <BootstrapDialog aria-labelledby="customized-dialog-title" open={open}>
        <div className="h-full flex flex-col justify-between">
          <DialogTitle
            sx={{ m: 0, p: 2, fontWeight: 600, fontSize: "18px" }}
            id="customized-dialog-title"
          >
            Transfer
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={(theme) => ({
              position: "absolute",
              right: 8,
              top: 8,
              color: theme.palette.grey[500],
            })}
          >
            <CloseIcon />
          </IconButton>
          <hr />
          {/* MAIN CONTENT */}
          <DialogContent
            sx={{
              height: "fit-content",
            }}
          >
            <div className="flex flex-col gap-6">
              {/* ORDER TYPE DROPDOWN */}
              <div>
                <EventEHRRadioButton
                  selectedValue={selectedType}
                  name=""
                  grid={true}
                  labelCustomStyle={{
                    marginLeft: "10px",
                    color: "#565656",
                  }}
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    rowGap: "21px",
                  }}
                  optionList={[
                    {
                      label: "Transfer Off Property",
                      value: "transferOffProperty",
                    },
                    {
                      label: "Admit to Observation",
                      value: "transferToCliniclocation",
                    },
                    { label: "Transfer to JHC", value: "transferToJHC" },
                    { label: "Clear EMS Scene", value: "clearEMS" },
                  ]}
                  handleOnChange={(value) => {
                    setSelectedType(value);
                  }}
                />
              </div>

              {selectedType === "transferOffProperty" && (
                <TransferOffPropertiesForm
                  getFormData={(data) => {
                    handleSubmitClick("transferOffProperty", data);
                  }}
                />
              )}

              {selectedType === "transferToJHC" && (
                <TransferToJHCForm
                  getFormData={(data) => {
                    handleSubmitClick("transferToJHC", data);
                  }}
                />
              )}

              {selectedType === "transferToCliniclocation" && (
                <TransferToClinicLocationForm
                  getFormData={(data) => {
                    handleSubmitClick("transferToClinicLocation", data);
                  }}
                />
              )}

              {selectedType === "clearEMS" && (
                <ClearEMSForm
                  getFormData={(data) => {
                    handleSubmitClick("clearEMS", data);
                  }}
                />
              )}
            </div>
          </DialogContent>
        </div>
      </BootstrapDialog>
    </React.Fragment>
  );
}
